import { render, staticRenderFns } from "./users-invite.vue?vue&type=template&id=07773ca9&"
import script from "./users-invite.vue?vue&type=script&lang=js&"
export * from "./users-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports